import { Navigate, useRoutes } from 'react-router-dom';

import AuthLayout from '../layout/Auth/AuthLayout';
import InstitutionDashboardLayout from '../layout/InstitutionDashoard/InstitutionDashoardLayout';
import EmailVerify from '../pages/Auth/EmailVerify/EmailVerify';
import ForgotPassword from '../pages/Auth/ForgotPassword/ForgotPassword';
import PasswordReset from '../pages/Auth/PasswordReset/PasswordReset';
// import SignIn from '../pages/Auth/SignIn/SignIn';
import HealthSignUp from '../pages/Auth/HealthSignup/HealthSIgnUp';
import HealthSignIn from '../pages/Auth/HealthSignIn/HealthSignIn';
// import SignUp from '../pages/Auth/SignUp/SignUp';
import SignupOtp from '../pages/Auth/SignupOtp/SignupOtp';
import HealthDashboardHome from '../pages/InstitutionDashboard/Dashboard/DashboardHome';
import Jobs from '../pages/InstitutionDashboard/Jobs/Jobs';
import Settings from '../pages/InstitutionDashboard/Settings/Settings';
import { NotFound404 } from '../pages/NotFound404';
import {
  ACCOUNT,
  APPLICATION,
  DASHBOARD,
  EMAIL_VERIFIED,
  FORGOT_PASSWORD,
  HEALTH_SIGNUP,
  HEALTH_SIGNIN,
  JOBS,
  NOTFOUND,
  PASSWORD_RESET,
  SIGNUP_OTP,
  UERS_SETTINGS,
  FORGOT_PASSWORD_SUCCESS,
  // MANAGE_POSTED_JOBS,
} from './routeConstants';
import Applications from '../pages/InstitutionDashboard/Applications/Applications';
// import ManagePostedJobs from '../pages/InstitutionDashboard/ManagePostedJobs/ManagePostedJobs';
import ManagePostJobApplicant from '../pages/InstitutionDashboard/ManagePostJobApplicant/ManagePostJobApplicant';
import ForgotPasswordSuccess from '../pages/Auth/ForgotPassword/ForgotPasswordSuccess';

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: <InstitutionDashboardLayout />,
      children: [
        {
          path: '/',
          element: <Navigate to={DASHBOARD} />,
        },
        { path: DASHBOARD, element: <HealthDashboardHome /> },
        { path: JOBS, element: <Jobs /> },
        { path: APPLICATION, element: <Applications /> },
        { path: UERS_SETTINGS, element: <Settings /> },
        // { path: LOCUMJOBS, element: <LocumJobs /> },
        // { path: APPLICATION, element: <Application /> },
        // { path: UERS_SETTINGS, element: <Settings /> },
        // {
        //   path: `${DASHBOARD}/${MANAGE_POSTED_JOBS}`,
        //   element: <ManagePostedJobs />,
        // },

        {
          path: `${APPLICATION}/:jobId`,
          element: <ManagePostJobApplicant />,
        },

        { path: NOTFOUND, element: <NotFound404 /> },
        { path: '*', element: <Navigate to={`/${NOTFOUND}`} replace /> },
      ],
    },

    {
      path: ACCOUNT,
      element: <AuthLayout />,
      children: [
        // { path: SIGNIN, element: <SignIn /> },
        // { path: SIGNUP, element: <SignUp /> },
        { path: HEALTH_SIGNUP, element: <HealthSignUp /> },
        { path: HEALTH_SIGNIN, element: <HealthSignIn /> },
        { path: SIGNUP_OTP, element: <SignupOtp /> },
        { path: EMAIL_VERIFIED, element: <EmailVerify /> },
        { path: PASSWORD_RESET, element: <PasswordReset /> },
        { path: FORGOT_PASSWORD, element: <ForgotPassword /> },
        { path: FORGOT_PASSWORD_SUCCESS, element: <ForgotPasswordSuccess /> },

        { path: NOTFOUND, element: <NotFound404 /> },
        { path: '*', element: <Navigate to={`/${NOTFOUND}`} replace /> },
      ],
    },
    { path: '*', element: <NotFound404 /> },
  ]);
}
